// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"ir_a big_tr","LeftMenu__link":"ir_b big_vt big_a big_rc","LeftMenu__link__icon":"ir_c"};